var lx = lx || {};
lx.privacy = lx.privacy || {};

lx.privacy.toggle = function (pVal, pSrcCode, pSrcId, pThis) {

    if (pVal == "CST") {
        alert("Custom");
    } else {

        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=privacyToggle",
                x01: pSrcCode,
                x02: pSrcId,
                x03: pVal
            },
            success: function (d) {
               $( "#" + pThis ).prop( "checked", true );
            }
        });

    }
}

// TODO cleanup after we ditch the old app
var privacyToggle = lx.privacy.toggle;